import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  List,
  ListItemButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import {
  selectedRecruiterAction,
  updateRecruiterStatusAction,
} from "../../redux/action";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { userSelector } from "../../user-redux/selector";
import Key from "../../../clientVariables.json";
import Checkbox from "@mui/material/Checkbox";

function AdminInactiveRecruitersList({ selectedRecruiters, setSelectedRecruiters }) {
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const { inactiveRecruiters, selectedRecruiter } = useSelector(appSelector);
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredRecruiter, setHoveredRecruiter] = useState(null);

  const handleCheckboxChange = (id) => {
    setSelectedRecruiters((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

  const getBackgroundColor = (index) => {
    const colors = [
      "rgb(234 193 184)",
      "rgb(162 195 168)",
      "rgb(144 154 202)",
      "rgb(121 154 202)",
      "rgb(104 174 202)",
    ];
    return colors[index % colors.length];
  };

  const handleClick = (recruiter) => {
    dispatch(selectedRecruiterAction(recruiter));
  };
  const handleMoreClick = (event, recruiter) => {
    setAnchorEl(event.currentTarget);
    dispatch(selectedRecruiterAction(recruiter));
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedRecruiter(null);
  };
  const handleUpdateStatus = async () => {
    const updatedData = {
      status: 1,
      recruiter_ids: selectedRecruiters,
    };

    let rec_data = {
      company_id: user?.companyid,
    };

    // Update status and fetch updated list
    await dispatch(updateRecruiterStatusAction(updatedData, rec_data, "inactive"));

    handleMenuClose();
  };

  return (
    <>
      <List>
        {inactiveRecruiters?.length > 0 ? (
          inactiveRecruiters.map((recruiter, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleClick(recruiter)}
              onMouseEnter={() => setHoveredRecruiter(recruiter.recruiter_id)}
              onMouseLeave={() => setHoveredRecruiter(null)}
              style={{
                backgroundColor:
                  selectedRecruiter.recruiter_id === recruiter?.recruiter_id
                    ? "rgba(25, 118, 210, 0.08)"
                    : "inherit",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box sx={{ width: 40, display: "flex", justifyContent: "center" }}>
                    {hoveredRecruiter === recruiter.recruiter_id ||
                      selectedRecruiters.includes(recruiter.recruiter_id) ? (
                      <Checkbox
                        checked={selectedRecruiters.includes(recruiter.recruiter_id)}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleCheckboxChange(recruiter.recruiter_id)}
                      />
                    ) : (
                      <Avatar
                        src={
                          recruiter?.image
                            ? `${Key.aws_bucket_profile}/attachments/user_${recruiter?.recruiter_uid}/profileimages/${recruiter?.image}`
                            : null
                        }
                        sx={{
                          bgcolor: getBackgroundColor(index),
                          textTransform: "capitalize",
                          fontSize: "13px",
                        }}
                      >
                        {recruiter?.recruiter_name?.[0]}
                      </Avatar>
                    )}
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      style={{ fontSize: "12px", fontWeight: "600" }}
                    >
                      {recruiter.recruiter_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ fontSize: "11px" }}
                    >
                      {recruiter.role}
                    </Typography>
                  </Box>
                </Box>
                {/* <IconButton
                  onClick={(event) => handleMoreClick(event, recruiter)}
                  size="small"
                  edge="end"
                >
                  <MoreVertIcon />
                </IconButton> */}
              </Box>
            </ListItemButton>
          ))
        ) : (
          <Typography variant="body1" style={{ padding: "16px" }}>
            No recruiters found
          </Typography>
        )}
      </List>
      {/* Menu for more options */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          disabled={selectedRecruiters.length === 0}
          onClick={handleUpdateStatus}
        >
          Active ({selectedRecruiters.length})
        </MenuItem>
      </Menu>
    </>
  );
}

export default AdminInactiveRecruitersList;
